export default "__VITE_PUBLIC_ASSET__341b3521__"